/**
 * modalButtons.tsx
 */
import Modals from '@shared/types/enums/modals';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import { store } from '@shared/store/store';

/**
 * Gets the modal style.
 */
const getModalStyle = () => {
  const { modal } = store.getState();
  switch (modal.current) {
    case Modals.CLOSE_PLAYER:
    case Modals.DEADMAN_ZAPPER:
    case Modals.EXIT_APP:
    case Modals.UPGRADE_RECORD_PLAN:
    case Modals.LOGOUT:
      return {
        bottom: `${388 * Screen.widthRatio}px`,
        height: `${196 * Screen.widthRatio}px`,
        flexDirection: 'column',
        justifyContent: 'space-between',
      };
      break;
    case Modals.DEVICE_NOT_COMPATIBLE:
      return {
        margin: `${40 * Screen.widthRatio}px auto 0 auto`,
        position: 'unset',
        flexDirection: 'column',
        gap: `${24 * Screen.widthRatio}px`,
      };
    case Modals.GENERIC_ERROR:
      return {
        bottom: `${240 * Screen.widthRatio}px`,
        margin: `${80 * Screen.widthRatio}px auto 0 auto`,
        position: 'unset',
      };
    case Modals.PARENTAL_PIN_GENERIC:
    case Modals.PARENTAL_PIN_ZAPPER:
    case Modals.PLAYER_ERROR:
      return {
        bottom: `${240 * Screen.widthRatio}px`,
        margin: `${40 * Screen.widthRatio}px auto`,
        position: 'unset',
      };
    case Modals.RECORDING_DELETE:
      return {
        bottom: `${300 * Screen.widthRatio}px`,
        flexDirection: 'column',
        gap: `${20 * Screen.widthRatio}px`,
      };
    case Modals.RECORDING_REQUEST:
      return {
        bottom: `${240 * Screen.widthRatio}px`,
        flexDirection: 'column',
        gap: `${20 * Screen.widthRatio}px`,
      };
    case Modals.UPGRADE_ADDON:
    case Modals.UPGRADE_PLAN:
      return {
        margin: 'unset',
        marginTop: `${40 * Screen.widthRatio}px`,
        position: 'unset',
      };
  }
  return {};
};

/**
 * Styled modal buttons.
 */
const ModalButtons = styled.div<React.CSSProperties>`
  align-items: center;
  bottom: ${146 * Screen.widthRatio}px;
  display: flex;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  width: fit-content;
  z-index: 1;
  ${() => {
    return getModalStyle();
  }}
`;

export default ModalButtons;
